// extracted by mini-css-extract-plugin
module.exports = {"option":"LookupEditorControl_option__3EYal"};